/* eslint-disable */
export default {
  to: 'A:',
  transferTo: 'Transferir a',
  blindTransfer: 'Transferir',
  warmTransfer: 'Preguntar primero',
  enterNameOrNumber: 'Ingresar número',
  toVoicemail: 'Enviar al buzón de voz',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"transferTo"@#@ @source: @#@"Transfer to"@#@
// @key: @#@"blindTransfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"warmTransfer"@#@ @source: @#@"Ask first"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter Number"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To voicemail"@#@
